import React from "react";
import {
  Grid,
  Card,
  CardMedia,
  CardContent,
  Typography,
  Chip,
  Box,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import CineMotion from "../../assets/CineMotion.png";
import ReelsImages from "../../assets/ReelsImages.png";
import ShortMovies from "../../assets/ShortMovies.jpg";
import BroadCast from "../../assets/BroadCast.jpg";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import BadgeImage from "../../assets/badge.png";

const cardsData = [
  {
    title: "Cinemotion",
    description: "Create cinematic AI videos with ease.",
    imageUrl: [CineMotion],
  },
  {
    title: "Photo Talks",
    description: "Bring your photos to life with AI-powered voiceovers.",
    imageUrl: ['https://devshowcasaai.blob.core.windows.net/677cfc53731e9e2f60a9113b/podcast_media/677cfc53731e9e2f60a9113b/6812186837ac9f090a4ca4fd/images/Woman_2025-06-02T04-56-03.150Z.jpg'],
  },
  {
    title: "Podcast",
    description: "Podcast your ideas with AI-powered podcasts.",
    imageUrl: [BroadCast],
  },
  {
    title: "Ramp Walk",
    description: "AI-powered fashion reels to elevate your style on social media.",
    imageUrl: ['https://devshowcasaai.blob.core.windows.net/677cfc53731e9e2f60a9113b/677cfc53731e9e2f60a9113b/685e428e94e0f8921c36a887/294040-ramp.jpg'],
  },
   {
    title: "Reels",
    description: "AI-generated reels ready for any social platform.",
    imageUrl: [ReelsImages],
  },
  {
    title: "ShortFilms",
    description: "Produce short films in minutes.",
    imageUrl: [ShortMovies],
  },
 
];

const StudioHome = () => {
  const navigator = useNavigate();
  return (
    <Box p={4} className="main-studio">
      <Box className="studio-home-header">
        <Typography variant="h4"  className="showcaseTitle">
         Your story, brought to motion
        </Typography>
        {/* <Typography variant="body1" className="showcaseDescription">
         Transform a Single Photo into a Captivating, PodCast-Ready Video.
        </Typography> */}
      </Box>
      <Grid container spacing={4} className="studio-home-card">
        {cardsData.map((card, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <Card
              onClick={() =>
                navigator(
                  card.title === "Cinemotion"
                    ? "/studio/cinemotion"
                    : card.title === "Podcast"
                    ? "/studio/podcast" : card.title === "Photo Talks" 
                    ? "/studio/photo-talks"  : card.title === "Ramp Walk"
                    ? "/studio/rampwalk" 
                    : "/studio/comingsoon"
                )
              }
              style={{
                cursor: "pointer",
              }}
            >
              <Box sx={{ position: "relative" }}>
                {card.imageUrl && (
                  <CardMedia
                    component="img"
                    height="300"
                    image={
                      Array.isArray(card.imageUrl)
                        ? card.imageUrl[0]
                        : card.imageUrl
                    }
                    className="modalCardMedia"
                    alt={card.title}
                  />
                )}
                {(card.title !== "Cinemotion" && card.title !=="Podcast" && card.title !== "Photo Talks"  && card.title !== "Ramp Walk" )  && (
                  <img
                    src={BadgeImage}
                    alt="Coming Soon"
                    className="coming-soon-banner"
                  />
                )}
                {(  card.title === "Cinemotion" || card.title === "Podcast"|| card.title === "Photo Talks" || card.title === "Ramp Walk" ) && (
                   <Box
                  sx={{
                    position: "absolute",
                    top: 10,
                    left: 0,
                    padding: "4px 8px",
                    borderRadius: "4px",
                  }}
                  >
                    <Chip label="New" className="chipstyle" size="small" style={{ margin: 0 }} />
                  </Box>
                )}
              </Box>
              <CardContent className="card-content">
                <Box
                  display="flex"
                  alignItems="center"
                  gap={1}
                  mb={1}
                  className="card-title"
                >
                  <Typography variant="h6" className="showcaseSubTitle">{card.title}</Typography>
                  <ArrowForwardIcon />
                </Box>
                <Typography variant="body1" className="card-description showcaseSubDescription">
                  {card.description}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default StudioHome;
